var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          attrs: { inline: "" },
          on: {
            submit: function ($event) {
              return _vm.add()
            },
          },
        },
        [
          _c("b-form-select", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover",
                modifiers: { hover: true },
              },
            ],
            staticClass: "mb-2",
            staticStyle: { width: "20%" },
            attrs: {
              placeholder: "Статус",
              options: _vm.statusList,
              title: _vm.help.status,
              required: "",
            },
            model: {
              value: _vm.newItem.status,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "status", $$v)
              },
              expression: "newItem.status",
            },
          }),
          _vm._v(" "),
          _c("b-form-select", {
            staticClass: "mb-2",
            staticStyle: { width: "20%" },
            attrs: {
              placeholder: "Кому",
              options: _vm.$store.getters.getUsersForList,
              required: "",
            },
            model: {
              value: _vm.newItem.user,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "user", $$v)
              },
              expression: "newItem.user",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            staticStyle: { width: "40%" },
            attrs: { placeholder: "Наименование начисления" },
            model: {
              value: _vm.newItem.reference,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "reference", $$v)
              },
              expression: "newItem.reference",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            staticStyle: { width: "15%" },
            attrs: { placeholder: "Сумма", type: "number" },
            model: {
              value: _vm.newItem.amount,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "amount", $$v)
              },
              expression: "newItem.amount",
            },
          }),
          _vm._v(" "),
          _c("b-form-select", {
            staticClass: "mb-2",
            attrs: { options: _vm.typeOfPaymentList, required: "" },
            model: {
              value: _vm.newItem.typeOfPayment,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "typeOfPayment", $$v)
              },
              expression: "newItem.typeOfPayment",
            },
          }),
          _vm._v(" "),
          _c("b-form-datepicker", {
            staticClass: "mb-2",
            attrs: {
              placeholder: "Дата",
              type: "data",
              "date-format-options": {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              },
              locale: "ru",
              required: "",
            },
            model: {
              value: _vm.newItem.dataSort,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "dataSort", $$v)
              },
              expression: "newItem.dataSort",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            staticStyle: { width: "100px" },
            attrs: { placeholder: "id Задачи", type: "number", readonly: "" },
            model: {
              value: _vm.newItem.task,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "task", $$v)
              },
              expression: "newItem.task",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            staticStyle: { width: "100px" },
            attrs: { placeholder: "id Сделки", type: "number", readonly: "" },
            model: {
              value: _vm.newItem.deal,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "deal", $$v)
              },
              expression: "newItem.deal",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            staticStyle: { width: "100px" },
            attrs: { placeholder: "id Компании", type: "number", readonly: "" },
            model: {
              value: _vm.newItem.company,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "company", $$v)
              },
              expression: "newItem.company",
            },
          }),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            staticStyle: { width: "100px" },
            attrs: { placeholder: "id Контакта", type: "number", readonly: "" },
            model: {
              value: _vm.newItem.contact,
              callback: function ($$v) {
                _vm.$set(_vm.newItem, "contact", $$v)
              },
              expression: "newItem.contact",
            },
          }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.modeEdit,
                  expression: "!modeEdit",
                },
              ],
              staticClass: "mb-2",
              attrs: { variant: "success" },
              on: {
                click: function ($event) {
                  return _vm.addOperation()
                },
              },
            },
            [_vm._v("Добавить")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.modeEdit,
                  expression: "modeEdit",
                },
              ],
              staticClass: "mb-2",
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.updateOperation()
                },
              },
            },
            [_vm._v("Изменить")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.modeEdit,
                  expression: "modeEdit",
                },
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value: _vm.modalConfirmDelete,
                  expression: "modalConfirmDelete",
                },
              ],
              staticClass: "mb-2",
              attrs: { variant: "danger" },
            },
            [_vm._v("Удалить")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalConfirmDelete,
            title: "Подтвердите удаление операции",
          },
          on: {
            ok: function ($event) {
              return _vm.deleteOperation()
            },
          },
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v("При надажтии Ок операция будет удалена!"),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }